import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import BlueSkeleton from '../../shared/BlueSkeleton';
import Title from '../../shared/Title';
import FFPaper from '../../shared/FFPaper';
import BigLabel from '../../shared/BigLabel';
import { VisionAwareContext } from '../../../context/visionaware-context';
import { useTranslation } from 'react-i18next';

// const ViewLink = styled(Button)(sx({
//     verticalAlign: 'middle',
//     textAlign:  {
//         xs: 'center',
//         sm: 'center',
//         md: 'center',
//         lg: 'left',
//         xl: 'left'
//     },
//     display: 'table-cell',
//     fontSize: 18,
//     fontWeight: 300,
//     textDecoration: 'underline',
//     width: '100%',
//     pt: 2,
//     pb: 1,
//     color:'text.secondary',
//     ml: 0,
//     pl: 0,
//     pr: 0
// }));


export default function TotalAlertsCard() {
    const { t } = useTranslation();

    return (
        <VisionAwareContext.Consumer>{
            ({ status, data, isFetching, error }) =>
                <Grid item={true} xs={12} >
                    <FFPaper
                        elevation={3}
                        sx={{
                            position: 'relative',
                            height: '100%',
                            pl: 3,
                            pr: 2,
                            pb: 1
                        }}
                    >
                        <Stack direction="row" divider={<Divider orientation="vertical" flexItem={true} />}
                            sx={{
                                justifyContent: 'space-evenly',
                                width: '100%',
                                pb: 1,
                                flexWrap: 'wrap'
                            }}>

                            <Stack sx={{
                                justifyContent: 'start',
                                flex: {
                                    xs: '1 0 100%',
                                    sm : '1 0 100%',
                                    md : '1 0 100%',
                                    lg : '1 0 35%',
                                    xl : '1 0 48%',
                                },
                                pt: 1,
                                pb: 1,
                                fontWeight: '500',
                                fontSize: {
                                    xs: 14,
                                    md: 16,
                                    textTransform: 'uppercase',
                                },
                                color: '#686868'
                            }}>
                                <Title notooltip={true}>{t('va_total_card_1')}</Title>

                                <Stack sx={{ pt: 1, alignItems: 'start' }}>
                                    <BigLabel sx={{ 
                                        textAlign:  {
                                            xs: 'center',
                                            sm: 'center',
                                            md: 'center',
                                            lg : 'center',
                                            xl: 'center'
                                        }                                    
                                     }}>
                                        {isFetching && <BlueSkeleton width={90} />}
                                        {status === 'success' && !isFetching && data?.totalEventsTagged}
                                    </BigLabel>
                                </Stack>
                            </Stack>

                            <Stack sx={{
                                justifyContent: 'start',
                                flex: {
                                    xs: '1 0 100%',
                                    sm : '1 0 100%',
                                    md : '1 0 100%',
                                    lg : '1 0 50%',
                                    xl : '1 0 50%',
                                },
                                pl: {
                                    xs: 0,
                                    sm: 0,
                                    md: 0,
                                    lg : 3,
                                    xl: 3
                                },
                                pt: 1,
                                pb: 1,
                                fontWeight: '500',
                                fontSize: {
                                    xs: 14,
                                    md: 16,
                                    textTransform: 'uppercase',
                                },
                                color: '#686868'
                                                                
                            }}>

                                <Title info={t('va_total_card_2_tooltip')}>{t('va_total_card_2')}</Title>

                                <Stack direction="row"
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        pt: 1,
                                        flexWrap: 'wrap'
                                    }}>

                                    <Box sx={{
                                        flex:  {
                                            xs: '1 0 100%',
                                            sm : '1 0 100%',
                                            md : '1 0 100%',
                                            lg : '1 0 58%',
                                            xl : '1 0 50%',
                                        },
                                    }}>
                                        <BigLabel sx={{ 
                                            textAlign:  {
                                                    xs: 'center',
                                                    sm: 'center',
                                                    md: 'center',
                                                    lg : 'center',
                                                    xl: 'center'
                                                },
                                            pr: {
                                                xs: 0,
                                                sm: 0,
                                                md: 0,
                                                lg : 2,
                                                xl: 1,
                                                xxl: 1
                                            },
                                            }}>
                                            {isFetching && <BlueSkeleton width={80} />}
                                            {status === 'success' && !isFetching && data?.missingTags}
                                        </BigLabel>
                                    </Box>

                                    {/* <Box sx={{
                                        flex:  {
                                            xs: '1 0 100%',
                                            sm : '1 0 100%',
                                            md : '1 0 100%',
                                            lg : '1 0 38%',
                                            xl : '1 0 48%',
                                        },
                                        display: 'flex',
                                        marginLeft: 0,
                                        pl: {
                                            xs: 0,
                                            sm: 0,
                                            md: 0,
                                            lg : 0,
                                            xl: 0,
                                            xxl: 3
                                        },
                                    }}>
                                        <ViewLink>View</ViewLink>
                                    </Box> */}
                                </Stack>
                            </Stack>
                        </Stack>
                    </FFPaper>
                </Grid>
        }
        </VisionAwareContext.Consumer>
    )

}